import { api } from "@api/api";
import { ReceivedBookMonthlyReport } from "./types";

export async function getReceivedBookMonthlyReportService(
  params?: Record<string, string>
): Promise<ReceivedBookMonthlyReport> {
  const { data } = await api.get<ReceivedBookMonthlyReport>(
    "v1/received_book_admin/monthly-report/",
    { params }
  );
  return data;
}
